import styled, { keyframes } from "styled-components";
import { colors } from "../contants";

/* Animasyonlar */
const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

const slideOut = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(100%); }
`;

/* HEADER */
export const HeaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9990;
  background: ${(props) =>
    props.sticky
      ? "rgba(14, 16, 32, 0.92)"
      : "linear-gradient(to bottom, rgba(6,9,24,0.65), rgba(6,9,24,0))"};
  box-shadow: ${(props) =>
    props.sticky ? "0 4px 20px rgba(0, 0, 0, 0.25)" : "none"};
  backdrop-filter: ${(props) => (props.sticky ? "blur(10px)" : "none")};
  transition: background 0.3s ease, box-shadow 0.3s ease;
`;

export const HeaderContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 1.1rem clamp(1.25rem, 4vw, 2.5rem);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderLogo = styled.img`
  width: 46px;
  height: auto;
`;

/* MOBILE ICON */
export const MobileMenuIcon = styled.div`
  display: none;
  color: white;
  cursor: pointer;
  line-height: 0;

  @media (max-width: 900px) {
    display: block;
  }
`;

/* ARKA PLAN KAPATAN TAM EKRAN */
export const MobileOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45); /* hafif karartma */
  z-index: 9998;

  opacity: ${(props) => (props.open ? 1 : 0)};
  pointer-events: ${(props) => (props.open ? "auto" : "none")};
  transition: opacity 0.25s ease;
`;

/* SAĞDAN GELEN YARIM EKRAN MENÜ (DRAWER) */
export const MobileMenu = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 78%; /* drawer genişliği, istersen 60-80% yapabilirsin */
  max-width: 320px;
  background: #ffffff;
  z-index: 9999;

  padding: 4rem 2rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.75rem;

  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.2);

  animation: ${(props) => (props.open ? slideIn : slideOut)} 0.3s forwards;
`;

/* X BUTONU */
export const MobileClose = styled.div`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  font-size: 1.75rem;
  line-height: 0;
  cursor: pointer;
  color: #0e1b4d;
`;

/* MENÜ ITEM */
export const MobileMenuButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  font-size: 1.15rem;
  font-weight: 600;
  text-align: left;
  color: #0e1b4d;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: ${colors.gold};
  }
`;

/* DESKTOP MENU */
export const HeaderButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(1.25rem, 2.5vw, 2.25rem);

  @media (max-width: 900px) {
    display: none;
  }
`;

export const HeaderButton = styled.a`
  position: relative;
  color: white;
  font-size: 0.95rem;
  font-weight: 500;
  letter-spacing: 0.01em;
  white-space: nowrap;
  cursor: pointer;
  padding-bottom: 4px;
  transition: color 0.2s ease;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 2px;
    background: ${colors.gold};
    transition: width 0.25s ease;
  }

  &:hover {
    color: ${colors.gold};
  }

  &:hover::after {
    width: 100%;
  }
`;
